var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgMallCenter = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M17.188 28.225h62.253v40.464H17.188z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.034 68.761V30.132M79.595 30.132v38.629M74.38 34.909H22.248v28.818H74.38V34.909Z"
  }), React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M70.274 39.016H26.355v20.602h43.92V39.016ZM39.505 59.618V39.016M57.481 59.618V39.016"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M84.628 74H12v-2.364a2.877 2.877 0 0 1 2.876-2.876h66.876a2.876 2.876 0 0 1 2.876 2.876V74Z"
  }), React.createElement("path", {
    fill: color,
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.157 22v4.411h.017a4.265 4.265 0 0 0 8.505 0h.034a4.265 4.265 0 0 0 8.506 0h.033a4.265 4.265 0 0 0 8.506 0h.033a4.265 4.265 0 0 0 8.506 0h.033a4.265 4.265 0 0 0 8.507 0h.033a4.265 4.265 0 0 0 8.506 0h.031a4.265 4.265 0 0 0 8.507 0h.032a4.265 4.265 0 0 0 8.507 0h.016V22H14.157Z"
  }));
};
export default SvgMallCenter;